import { FC } from "react";
import { Card, LinearProgress, Stack } from "@mui/material";
import { useAppSelector } from "@/store/hooks";
import { normalizedCostWidgetSetupVisualizationChartTypeSelector } from "@/store/dashboards/selectors/setups/normalized-cost-widget/visualization/normalizedCostWidgetSetupVisualizationChartTypeSelector";
import { WidgetSetupContentWrapper } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/common/WidgetSetupContentWrapper";
import { widgetSetupContentChartHeight } from "@/components/pages/dashboard/utils/constants/stylings";
import { normalizedCostWidgetSetupDataLoadingSelector } from "@/store/dashboards/selectors/widgets/normalized-cost-widget/setup/normalizedCostWidgetSetupDataLoadingSelector";
import { NormalizedCostWidgetSetupSubHeader } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/normalized-cost-widget/content/NormalizedCostWidgetSetupSubHeader";
import { NormalizedCostWidgetSetupAggregations } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/normalized-cost-widget/content/NormalizedCostWidgetSetupAggregations";

import { NormalizedCostWidgetSetupChartView } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/normalized-cost-widget/content/NormalizedCostWidgetSetupChartView";

import { NormalizedCostWidgetSetupTableView } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/normalized-cost-widget/content/NormalizedCostWidgetSetupTableView";

export const NormalizedCostWidgetSetupContent: FC = () => {
  const chartType = useAppSelector(
    normalizedCostWidgetSetupVisualizationChartTypeSelector,
  );

  const loading = useAppSelector(normalizedCostWidgetSetupDataLoadingSelector);

  return (
    <WidgetSetupContentWrapper>
      <Card elevation={3} sx={widgetCardStyles}>
        {loading && <LinearProgress />}

        <NormalizedCostWidgetSetupSubHeader />

        <Stack flex={1} p={2}>
          <NormalizedCostWidgetSetupAggregations />

          {chartType === "table" && <NormalizedCostWidgetSetupTableView />}

          {!["numeral", "table"].includes(chartType) && (
            <NormalizedCostWidgetSetupChartView />
          )}
        </Stack>
      </Card>
    </WidgetSetupContentWrapper>
  );
};

const widgetCardStyles = {
  height: widgetSetupContentChartHeight,
  display: "flex",
  flexDirection: "column",
};
